import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import getArray from 'utils/accessors/getArray.util';
import getObject from 'utils/accessors/getObject.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

// Billing Selectors
export const selectBillingError = nullBind(getAnyOrNull, 'settings.billing.errorMessage');
export const selectBillingIsFetching = nullBind(getAnyOrNull, 'settings.billing.isFetching');
export const selectBillingInvoices = nullBind(getArray, 'settings.billing.invoices');
export const selectBillingStripeToken = nullBind(getObject, 'settings.billing.stripeToken');
export const selectBillingCoupon = nullBind(getObject, 'settings.billing.coupon');
export const selectBillingPlan = nullBind(getArray, 'settings.billing.billingPlan');
export const selectBillingCardData = nullBind(getObject, 'settings.billing.stripeCardDetails');
export const selectBillingTrial = nullBind(getAnyOrNull, 'settings.billing.trialResponseText');

export const selectBookingCategoryServices = ($) => $?.settings?.onlineBooking?.settingsData?.category_services;
export const selectBookingStripeAccountStatus = ($) => $?.settings?.onlineBooking?.settingsData?.stylist_service_data;
export const selectBookingIsSettingsDataFetched = ($) => $?.settings?.onlineBooking?.isSettingsDataFetched;
